import { createContext, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DataHelper } from 'src/services/dataHelper';

export const CartContext = createContext({
  cartCount: 0,
  loading: false,
  refreshCartCount: () => Promise.resolve()
});

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const refreshCartCount = useCallback(async () => {
    try {
      setLoading(true);
      const response = await new DataHelper().operationsDetailsByOrderStatus('Operations', null, 'MoveToCart');
      if (response?.status === 200) {
        const count = response.data?.details?.length || 0;
       // alert(count)
        setCartCount(count);
      } else {
        setCartCount(0);
      }
    } catch (err) {
      console.error('Error fetching cart count:', err);
      setCartCount(0);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshCartCount();
  }, [refreshCartCount]);

  return (
    <CartContext.Provider
      value={{
        cartCount,
        loading,
        refreshCartCount
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

CartProvider.propTypes = {
  children: PropTypes.node.isRequired
};